import { filter } from 'rxjs/operators';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { MenuItem } from 'primeng/api';
import { HisNavigationService } from '../../core/service/base/his-navigation.service';
import { HisNavigationMenuService } from '../../core/service/base/his-navigation-menu.service';
import { HisSessionStorageService } from '../../core/service/base/his-session-storage.service';

@Component( {
    selector: 'his-submenu',
    templateUrl: './his-submenu.component.html',
    styleUrls: ['./his-submenu.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSubmenuComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private navigationService = inject(HisNavigationService);
    private navigationMenuService = inject(HisNavigationMenuService);
    private sessionStorageService = inject(HisSessionStorageService);


    children: MenuItem[] = new Array<MenuItem>();

    activeItem: MenuItem;

    ngOnInit() {
        this.route.queryParams.pipe(
            filter( (params: Params) => params.navigationPosition ) )
            .subscribe( () => {
                this.activeItem = this.navigationMenuService.getActiveMenuItem();
                console.log( 'submenu: activeItem =', this.activeItem );
                this.findChildren( this.activeItem );
            } );
        this.sessionStorageService.removeSearchKeys();
    }

    private findChildren( menuItem: MenuItem ) {
        if ( menuItem ) {
            if ( menuItem.items && menuItem.items.length > 0 ) {
                this.children = menuItem.items as MenuItem[];
            }
        } else {
            console.log( 'submenu: menuItem is null -> access denied!' );
            this.navigationService.navigateToAccessDenied();
        }
    }
}
